var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';

var Action = function (_React$PureComponent) {
  _inherits(Action, _React$PureComponent);

  function Action() {
    _classCallCheck(this, Action);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Action.prototype.render = function render() {
    return React.createElement(
      'span',
      _extends({}, this.props, { className: 'idyll-action' }),
      this.props.children
    );
  };

  return Action;
}(React.PureComponent);

Action._idyll = {
  name: "Action",
  tagType: "open",
  children: ["action text"],
  props: [{
    name: "onClick",
    type: 'event',
    example: '`x = !x`'
  }, {
    name: "onMouseEnter",
    type: 'event',
    example: '`x = true`'
  }, {
    name: "onMouseLeave",
    type: 'event',
    example: '`x = false`'
  }]
};

export default Action;


//////////////////
// WEBPACK FOOTER
// ./node_modules/idyll-components/dist/es/action.js
// module id = 706
// module chunks = 0